module.exports = __webpack_public_path__ + "img/latitude-interest-free-logo-white-plain.19e195e8.svg";